import {StyleConfig} from '@chakra-ui/react'

const plpBannerPromo: StyleConfig = {
    baseStyle: {
        box: {
            backgroundColor: 'background.brand',
        },
        textblock: {
            position: 'relative',
            textAlign: {base: 'center', md: 'left'},
        },
    },
}

export default plpBannerPromo
